
import {
    ISKN_EXPLORER_SET_ISKN_DATE_ACTION_TYPE,
} from '../sagas/isknExplorer';

const initialState = {
    isknDate: null
};

export function getIsknDate(state) {
    return state.isknDate;
}

function setIsknDate(state, action) {
    return {
        ...state,
        isknDate: action.isknDate
    };
}

export default function iskn(state = initialState, action) {
    switch (action.type) {
        case ISKN_EXPLORER_SET_ISKN_DATE_ACTION_TYPE:
            return setIsknDate(state, action);

        default:
            return state;
    }
}